import "../../assets/css/updates-section.css";
import Section from "../Section/Section";

export function UpdateSection(props) {
  const { children, classList="", isLoading=false } = props;

  return (
    <Section isLoading={isLoading} classList={`UpdateSection Section three-column__main my-community ${classList} section-container section-container__updates`}>
      { children }
    </Section>
  );
}

export default UpdateSection;